"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const date_1 = require("./date");
/**
 * Localized **date-fns** `format` function
 *
 * *https://date-fns.org/v2.21.2/docs/format#description*
 *
 * @param {number | Date} date
 * @param {string} formatStr
 * @param {string} locale
 * @returns {string} formatted date
 */
const formatDate = (date, formatStr, locale) => (0, date_fns_1.format)(date, date_1.locales[formatStr] || formatStr, {
    locale: date_1.dateFnsLocales[locale],
});
exports.default = formatDate;
